import React, { useState } from "react";
import { motion } from "framer-motion";
import { FiSend, FiMapPin, FiPhone, FiMail, FiWifi } from "react-icons/fi";
import Title from "../home/Title";
import emailjs from 'emailjs-com';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [errors, setErrors] = useState({
    name: false,
    email: false,
    message: false
  });
  const [successMsg, setSuccessMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: false }));
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const newErrors = {
      name: !formData.name,
      email: !formData.email || !validateEmail(formData.email),
      message: !formData.message
    };

    setErrors(newErrors);

    if (Object.values(newErrors).some(error => error)) {
      setIsLoading(false);
      return;
    }

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      message: formData.message,
    };

    try {
      await emailjs.send(
        "service_tir40ic",     // Замените на ваш Service ID
        "template_pbzjnlg",    // Замените на ваш Template ID
        templateParams,
        "QMBD0vCgtikyhJ-Q6"      // Замените на ваш Public Key
      );

      setSuccessMsg(`Уважаемый(ая) ${formData.name}, ваше сообщение успешно отправлено!`);
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      setSuccessMsg("Произошла ошибка при отправке. Пожалуйста, попробуйте позже.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="contact" className="w-full py-16 bg-gray-900">
      <div className="container mx-auto px-4">
        <Title title="Свяжитесь" subTitle="со мной" />

        {/* Контактная информация */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16"
        >
          <div className="bg-gray-800 p-6 rounded-xl border border-gray-700">
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-blue-500 p-2 rounded-lg">
                <FiMapPin className="text-white text-xl" />
              </div>
              <div>
                <h3 className="text-gray-400 text-sm uppercase">Адрес</h3>
                <p className="text-gray-200">Казахстан, Костанай</p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="bg-purple-500 p-2 rounded-lg">
                <FiPhone className="text-white text-xl" />
              </div>
              <div>
                <h3 className="text-gray-400 text-sm uppercase">Телефон</h3>
                <p className="text-gray-200">+7 (***) 639-92-11</p>
              </div>
            </div>
          </div>

          <div className="bg-gray-800 p-6 rounded-xl border border-gray-700">
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-blue-500 p-2 rounded-lg">
                <FiMail className="text-white text-xl" />
              </div>
              <div>
                <h3 className="text-gray-400 text-sm uppercase">Email</h3>
                <p className="text-gray-200">a7softday@gmail.com</p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="bg-purple-500 p-2 rounded-lg">
                <FiWifi className="text-white text-xl" />
              </div>
              <div>
                <h3 className="text-gray-400 text-sm uppercase">Статус</h3>
                <p className="text-green-400">Доступен для работы</p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Форма обратной связи */}
        <div className="w-full">
          <Title title="Отправить" subTitle="сообщение" />

          {successMsg ? (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-center text-lg p-8 text-blue-400 bg-gray-800 rounded-xl"
            >
              {successMsg}
            </motion.div>
          ) : (
            <motion.form
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              onSubmit={handleSubmit}
              className="bg-gray-800 p-8 rounded-xl border border-gray-700"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-gray-400 mb-2">Ваше имя</label>
                  <input
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className={`${
                      errors.name ? "border-red-500" : "border-gray-700 focus:border-blue-500"
                    } w-full bg-gray-700 border-2 px-4 py-3 text-gray-200 rounded-lg outline-none transition-colors`}
                    type="text"
                    placeholder="Иван Иванов"
                  />
                  {errors.name && <p className="text-red-500 text-sm mt-1">Пожалуйста, введите имя</p>}
                </div>

                <div>
                  <label className="block text-gray-400 mb-2">Ваш email</label>
                  <input
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={`${
                      errors.email ? "border-red-500" : "border-gray-700 focus:border-blue-500"
                    } w-full bg-gray-700 border-2 px-4 py-3 text-gray-200 rounded-lg outline-none transition-colors`}
                    type="email"
                    placeholder="ivan@example.com"
                  />
                  {errors.email && <p className="text-red-500 text-sm mt-1">Пожалуйста, введите корректный email</p>}
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-gray-400 mb-2">Ваше сообщение</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className={`${
                    errors.message ? "border-red-500" : "border-gray-700 focus:border-blue-500"
                  } w-full bg-gray-700 border-2 px-4 py-3 text-gray-200 rounded-lg outline-none transition-colors resize-none`}
                  placeholder="Расскажите о вашем проекте..."
                  rows="5"
                ></textarea>
                {errors.message && <p className="text-red-500 text-sm mt-1">Пожалуйста, введите сообщение</p>}
              </div>

              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                type="submit"
                disabled={isLoading}
                className="flex items-center justify-center gap-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-3 rounded-lg font-medium hover:opacity-90 transition-opacity disabled:opacity-50"
              >
                {isLoading ? (
                  "Отправка..."
                ) : (
                  <>
                    Отправить сообщение
                    <FiSend />
                  </>
                )}
              </motion.button>
            </motion.form>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;
